import React, { useState } from "react";
import axios from "axios";
import FacebookLogin from "react-facebook-login-lite";
import {
  GoogleOAuthProvider,
  GoogleLogin,
  useGoogleLogin,
} from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import "./styles.css";
import loginPng from "../../../public/assets/login.png";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";

const Login = ({ onClose }) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [isRegister, setIsRegister] = useState(Boolean);
  const [isLogin, setIsLogin] = useState(true);
  const facebookAppId = process.env.REACT_APP_FACEBOOK_APP_ID;
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  const loginDisabled = process.env.REACT_APP_LOGIN_DISABLED === "true";
  const [t, i18n] = useTranslation();

  const handleAuthSuccess = (token, provider) => {
    localStorage.setItem("authToken", token);
    localStorage.setItem("provider", provider);
    window.location = '/';
    window.location.reload();

  };

  const responseFacebook = async (response) => {
    if (response.user.email && response.user.id) {
      const body = {
        email: response.user.email,
        provider: "facebook",
        provider_id: response.user.id,
      };

      try {
        const res = await axios.post(
          process.env.BACK_RND_URL + "/auth/social",
          body
        );
        handleAuthSuccess(res.data.access_token, res.data.provider);
      } catch (error) {
        console.error("Facebook login failed:", error);
      }
    }
  };

  const handleGoogleSuccess = async (response) => {
    const userObject = jwtDecode(response.credential);
    const body = {
      email: userObject.email,
      provider: "google",
      provider_id: userObject.sub,
    };

    try {
      const res = await axios.post(
        process.env.BACK_RND_URL + "/auth/social",
        body
      );
      handleAuthSuccess(res.data.access_token, res.data.provider);
    } catch (error) {
      console.error("Google login failed:", error);
    }
  };

  const handleGoogleFailure = (response) => {
    console.error("Google login failed:", response);
  };

  const isRegisterAction = () => {
    setIsRegister(true)
    setIsLogin(false)
  }

  const isLoginAction = () => {
    setIsRegister(false)
    setIsLogin(true)
  }

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    const email = event.target.email.value;
    const password = event.target.password.value;
    const gRecaptcha = recaptchaRef.current.getValue();

    const body = {
      email,
      password,
      g_recaptcha: gRecaptcha,
      provider: "latamshipping",
      provider_id: "1",
    };

    try {
      const res = await axios.post(
        process.env.BACK_RND_URL + "/auth/social",
        body
      );
      handleAuthSuccess(res.data.access_token, res.data.provider);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        setErrorMessage(t("incorrect_password"));
      } else {
        console.error("Latamshipping login failed:", error);
      }
    }
  };

  const recaptchaRef = React.createRef();

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <div className="login-modal">
        <div className="login-container">
          <div className="login-image">
            <img src={loginPng} alt="Delivery person with a package" />
          </div>
          <div className="login-form">
            <h2>{t("login_register_seconds")}</h2>
            <p>{t("to_qoute_shipment")}</p>
            {loginDisabled && (
              <p className="login-disabled-text">{t("login_methods")}</p>
            )}
            <div
              className={`social-buttons-container ${loginDisabled ? "disabled" : ""
                }`}
            >
              <FacebookLogin
                appId={facebookAppId}
                onSuccess={responseFacebook}
                onFail={(error) =>
                  console.error("Facebook login failed:", error)
                }
                className="facebook-button"
                height="40px"
              />
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={handleGoogleFailure}
                className="google-button"
                size="large"
                width="240px"
              />
            </div>
            <div className="or-separator">{t("or")}</div>
            <form className="password-form" onSubmit={handleFormSubmit}>
              <input type="email" name="email" placeholder="E-mail" required />
              <p className="login-info-text">Si no tienes cuenta  puedes ingresar CUALQUIER clave para quedar registrado como cliente nuevo</p>
              <input
                type="password"
                name="password"
                placeholder={t("password")}
                required
              />

              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey="6Ld62hYqAAAAAMVr76E-r2pWTA040PnPS6BLICen"
                hl={JSON.parse(localStorage.getItem('lenguaje'))?.label || 'es'}
              />

              {errorMessage && (
                <p className="error-message-login">{errorMessage}</p>
              )}
              <button type="submit" className="login-button-modal">

                {isRegister && (
                  t("sing_up")
                )}

                {isLogin && (
                  t("login")
                )}

              </button>

              <p className="login-disabled-text">
                {isRegister && (
                  <a onClick={isLoginAction}> {t("login")} </a>
                )}

                {isLogin && (
                  <a onClick={isRegisterAction}>{t("sing_up")} </a>
                )}

                <a href={'https://app.latamshipping.com/password/reset'} target={'_blank'}>{t("forget_password")}</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default Login;
